import { config } from '@/config';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getRemoteConfig, fetchAndActivate, getString } from 'firebase/remote-config';

const firebase = initializeApp(config.firebase);

const remoteConfig = getRemoteConfig(firebase);

const auth = getAuth(firebase);
auth.useDeviceLanguage();

export async function signinFirebase(email: string, password: string): Promise<string> {
	try {
		const userCredential = await signInWithEmailAndPassword(auth, email, password);
		return userCredential.user.getIdToken();
	} catch (err) {
		return '';
	}
}

export async function loadConfig(configName: string) {
	remoteConfig.settings.minimumFetchIntervalMillis = 1000;
	await fetchAndActivate(remoteConfig);
	remoteConfig.settings.minimumFetchIntervalMillis = 43200000;
	return getString(remoteConfig, configName);
}
